// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__BJ1ax","shimmer":"Skeleton_shimmer__-grfh","chart":"Skeleton_chart__HN3Fp","card":"Skeleton_card__qJWkH"};